module.exports = __webpack_public_path__ + "img/coupon-4-fill.a11375a2.svg";